/** Primary navigation model (ARCHITECTURE §3.4). Routes and page metadata in
 *  one place so the sidebar, mobile drawer, and router stay in sync. */
export interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly icon: string;
  readonly group: "Ledger" | "Reporting" | "Operate";
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: "/dashboard", label: "Dashboard", icon: "▦", group: "Ledger" },
  { to: "/journal", label: "Journal", icon: "✎", group: "Ledger" },
  { to: "/accounts", label: "Chart of Accounts", icon: "▤", group: "Ledger" },
  { to: "/trial-balance", label: "Trial Balance", icon: "⚖", group: "Reporting" },
  { to: "/statements", label: "Statements", icon: "▧", group: "Reporting" },
  { to: "/import-export", label: "Import / Export", icon: "⇄", group: "Operate" },
  { to: "/reconcile", label: "Reconciliation", icon: "⇌", group: "Operate" },
  { to: "/settings", label: "Settings", icon: "⚙", group: "Operate" },
];

export const NAV_GROUPS = ["Ledger", "Reporting", "Operate"] as const;
